import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import TextLink from 'components/TextLink';
import { jsx as _jsx } from "react/jsx-runtime";
export var AccessLink = function AccessLink(_ref) {
  var children = _ref.children,
    accessTabLink = _ref.accessTabLink;
  var location = useLocation();
  return /*#__PURE__*/_jsx(TextLink, {
    as: NavLink,
    to: {
      pathname: accessTabLink,
      search: location.search
    },
    bold: true,
    children: children
  });
};